export type BannerContentType = "fullscreen" | "mrec" | "banner";

/**
 * Classifies banner dimensions for TrePreview chrome (matches ViewMaster bid logic
 * plus tall narrow units as MREC-style slots).
 */
export function classifyBannerDimensions(
  width: number,
  height: number
): BannerContentType {
  if (height <= 90) {
    return "banner";
  }
  if ((width === 300 && height === 250) || (width === 320 && height === 250)) {
    return "mrec";
  }
  if (height > width && height >= 250) {
    return "mrec";
  }
  return "fullscreen";
}

/**
 * Classifies bid w/h for ViewMaster (`vm=true`) previews. Stricter than
 * {@link classifyBannerDimensions}.
 */
export function classifyViewMasterBidDimensions(
  width: number,
  height: number
): BannerContentType {
  if (height <= 90) {
    return "banner";
  }
  if (width === 300 && height === 250) {
    return "mrec";
  }
  return "fullscreen";
}

/** Leaderboard / tablet banner units should default to tablet device chrome. */
export function shouldDefaultTabletDevice(
  width: number,
  height: number,
  deviceParam: string | null
): boolean {
  if (deviceParam === "tablet") {
    return true;
  }
  return width >= 728 && height <= 90;
}

export function parsePositiveInt(value: string | null): number | undefined {
  if (value == null || value === "") {
    return undefined;
  }
  const n = Number.parseInt(value, 10);
  if (!Number.isFinite(n) || n <= 0) {
    return undefined;
  }
  return n;
}

/** Default iframe dimensions when `size` is set without `w`/`h` (legacy URLs). */
export function defaultSlotDimensions(contentType: "banner" | "mrec"): {
  width: number;
  height: number;
} {
  if (contentType === "banner") {
    return { width: 320, height: 50 };
  }
  return { width: 300, height: 250 };
}

export function applySlotIframeStyles(
  contentType: "banner" | "mrec",
  width: number,
  height: number
): void {
  const iframeWrappers = document.querySelectorAll(".iframe-wrapper");
  iframeWrappers.forEach((wrapper) => {
    const el = wrapper as HTMLElement;
    if (contentType === "banner") {
      el.style.setProperty("--iframe-width", "100%");
      el.style.setProperty("--iframe-height", `${height}px`);
    } else {
      el.style.setProperty("--iframe-width", `${width}px`);
      el.style.setProperty("--iframe-height", `${height}px`);
    }
  });
}

export function clearSlotIframeStyles(): void {
  const iframeWrappers = document.querySelectorAll(".iframe-wrapper");
  iframeWrappers.forEach((wrapper) => {
    const el = wrapper as HTMLElement;
    el.style.removeProperty("--iframe-width");
    el.style.removeProperty("--iframe-height");
  });
}
